import './instrument';
import './index.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';
import { StrictMode } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner.tsx';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { store } from '@/store/store.ts';
import { generateColors } from '@mantine/colors-generator';
import { Button, createTheme, MantineProvider } from '@mantine/core';
import * as Sentry from '@sentry/react';
import routes from './Routes/index.tsx';
import { queryClient } from './lib/queryClient.ts';
import errorFallback from './components/ErrorFallback.tsx';
import './App.css';

const theme = createTheme({
  primaryColor: 'custom-blue',
  colors: { 'custom-blue': generateColors('#4a96d9') },
  components: {
    Button: Button.extend({
      defaultProps: { color: 'custom-blue', variant: 'outline' },
    }),
  },
});

const container = document.getElementById('root');
if (!container) throw Error("root element can't be found!");

const root: Root = createRoot(container);
root.render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ eventId, resetError }) =>
        errorFallback('La Caisse', eventId, resetError)
      }
    >
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <MantineProvider theme={theme}>
            <Toaster expand richColors toastOptions={{ className: '!h-18' }} />
            <RouterProvider
              future={{ v7_startTransition: true }}
              router={routes}
            />
            <ReactQueryDevtools initialIsOpen={false} />
          </MantineProvider>
        </QueryClientProvider>
      </Provider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

if (import.meta?.hot) {
  import.meta.hot.dispose(() => {
    root.unmount();
  });
}
